import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../auth/AuthProvider";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import LoadingSpinner from "../../../loadingSpinner/LoadingSpinner.jsx";
export default function AudioP2() {
  const { answerLabel, hashed, id, phaseTitle } = useParams();

  const { apiUrl, user, googleUser, payed, setUserProgress, userProgress } =
    useContext(AuthContext);
  const [goToQuestion, setGoToQuestion] = useState(null);

  const [question, setQuestion] = useState([]);
  const [phase3, setPhase3] = useState([]);

  const [video, setVideo] = useState({});
  const [loading, setLoading] = useState(true);

  const [currentQuestion, setCurrentQuestion] = useState(null);

  const location = useLocation();

  const navigate = useNavigate();

  useEffect(() => {
    async function handleAxios() {
      const encodedLabel = encodeURIComponent(answerLabel);

      try {
        setLoading(true);

        const [question, phase, video] = await Promise.all([
          axios.get(`${apiUrl}/question/byPhaseAndTheme/${phaseTitle}/${id}`),
          axios.get(`${apiUrl}/question/byPhase/${3}`),
          axios.get(`${apiUrl}/answer/label/${encodedLabel}`),
        ]);

        setQuestion(question.data.sort((a, b) => a.id - b.id));
        setPhase3(phase.data.sort((a, b) => a.id - b.id));
        setVideo(video.data);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    }

    handleAxios();
  }, []);

  useEffect(() => {
    if (question) {
      const index = question.findIndex((q) => q.hashed === hashed);
      const nextQuestion = index != -1 ? question[index + 1] : null;

      setCurrentQuestion(question[index]);

      if (nextQuestion !== null) setGoToQuestion(nextQuestion);
    }
  }, [question]);

  useEffect(() => {
    if (!user && !googleUser) {
      localStorage.setItem("postLoginRedirect", location.pathname);
      navigate("/login", { replace: true });
    }
  }, [user, googleUser, id, navigate]);

  useEffect(() => {
    if (!user && !googleUser) return;

    if (user) {
      const progress = {
        themeSlug: id,
        phaseName: phaseTitle,
        uuid: hashed,
        answerTitle: answerLabel,
        username: user.username,
      };
      axios.post(`${apiUrl}/user-progress/add`, progress).then((response) => {
        setUserProgress(response.data);
      });
    }

    if (googleUser) {
      const progress = {
        themeSlug: id,
        phaseName: phaseTitle,
        uuid: hashed,
        answerTitle: answerLabel,
        googleEmail: googleUser.email,
      };

      axios.post(`${apiUrl}/user-progress/add`, progress).then((response) => {
        setUserProgress(response.data);
      });
    }
  }, [user, googleUser]);

  function audioEnded() {
    if (goToQuestion) {
      navigate(`/session/${id}/${phaseTitle}/${goToQuestion.hashed}`);
    } else {
      if (user || googleUser) {
        navigate(`/session/${id}/${phase3[0].phaseTitle}/${phase3[0].hashed}`);
      } else {
        navigate("/login");
      }
    }
  }
  if (loading)
    return (
      <LoadingSpinner
        customBg={"rgba(20, 13, 8, 0.92)"}
        customColor={"white"}
      />
    );
  return (
    <>
      <AudioPlayer
        audioSrc={video?.reflectionVideoUrl}
        audioEnded={audioEnded}
        title={answerLabel}
        phase={phaseTitle}
        question={currentQuestion?.questionNumber}
        questionName={currentQuestion?.name}
        subtitle={video?.description}
      />
      {/* <section>
        <div>
          <audio
            src={`/${video?.reflectionVideoUrl}`}
            controls
            autoPlay
            onEnded={audioEnded}
          >
            Audio don't work
          </audio>
        </div>
      </section> */}
    </>
  );
}
